import { useState } from "react";
import { motion } from "framer-motion";
import { Eyebrow, Reveal, EASE } from "./Reveal";
import { VALUES } from "./data";

export const Values = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="values" className="bg-mist py-24 sm:py-32" data-testid="values-section">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Eyebrow>What we stand for</Eyebrow>
          <Reveal>
            <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-navy sm:text-5xl">
              Five principles, <em className="font-serif font-normal italic text-copper">every</em> trade.
            </h2>
          </Reveal>
          <Reveal delay={0.1}><p className="mt-6 max-w-sm text-base leading-relaxed text-slate-600">The standards our suppliers and buyers can hold us to.</p></Reveal>
        </div>
        <div className="lg:col-span-8">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.05}>
              <button
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                data-testid={`value-item-${i}`}
                className="group grid w-full grid-cols-12 items-baseline gap-4 border-t border-navy/12 py-6 text-left last:border-b"
              >
                <span className="col-span-2 font-mono text-xs text-slate-500 sm:col-span-1">0{i + 1}</span>
                <span className={`col-span-10 font-display text-3xl font-extrabold tracking-tight transition-colors duration-500 sm:col-span-6 sm:text-5xl ${active === i ? "text-navy" : "text-navy/30"}`}>
                  {v.title}
                </span>
                <motion.span
                  initial={false}
                  animate={{ opacity: active === i ? 1 : 0.55, x: active === i ? 0 : 8 }}
                  transition={{ duration: 0.5, ease: EASE }}
                  className="col-span-12 text-sm leading-relaxed text-slate-600 sm:col-span-5 md:text-base"
                >
                  {v.text}
                </motion.span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
